//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
    props: {
        rows: {
        },
        showDetail: {
            default: false,
            type: Boolean,
        }
    },

    data() {
        return {
        }
    },
    mounted: function () {
        console.log(this.showDetail)
    },
    methods: {
        parseName(name) {
            //Remove "Vendas" or "Stocks" from name
            return name.replace("Vendas", "").replace("Stocks", "")
        },
        redirect(date) {
            this.$router.push({ name: 'fileUploads', params: { propDate: date } })
        }
    }



}


